import React from "react";

const inProcessErrorMarker = "уже заполняется пользователем";

const buildMessage = (userName) =>
    userName
        ? `Заказ уже заполняется пользователем ${userName}. Создание заявки недоступно.`
        : "Заказ уже заполняется другим пользователем. Создание заявки недоступно.";

export const isDistributionBidInProcessError = (message) => {
    return !!message && message.includes(inProcessErrorMarker);
};

const DistributionBidInProcessModalBody = ({ back, buttonText = "Закрыть", message, userName }) => {
    return (
        <div>
            <div className="text-center pb-4">{message || buildMessage(userName)}</div>
            <div className="d-flex justify-content-center">
                <button type="button" className="btn btn-sm btn-brand" onClick={back}>
                    {buttonText}
                </button>
            </div>
        </div>
    );
};

export const distributionBidInProcessModal = ({ buttonText, message, onCloseAction, userName } = {}) => ({
    name: "default",
    withoutHeader: true,
    withoutEscClose: true,
    onCloseAction,
    CustomBody: DistributionBidInProcessModalBody,
    bodyData: { buttonText, message, userName },
});
